let apiConfig: any;

const localDev = {
    getVerificationCode: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/getVerificationCode",
    postVerifyCode: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/postVerifyCode",
    manageCompanyUser: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/manageCompanyUser",
    archiveCompanyUser: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/archiveCompanyUser",
    activateCompanyUser: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/activateCompanyUser",
    manageAdminUser: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/manageAdminUser",
    archiveAdminUser: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/archiveAdminUser",
    activateAdminUser: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/activateAdminUser",
    archiveCourse: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/archiveCourse",
    archiveLessonPlan: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/archiveLessonPlan",
    launchCourse: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/launchCourse",
    launchLessonPlan: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/launchLessonPlan",
    manageCourseUsers: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/manageCourseUsers",
    manageLessonPlanUsers: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/manageLessonPlanUsers",
    fetchDashboardMetrics: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/fetchDashboardMetrics",
    fetchCourseProgressMetrics: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/fetchCourseProgressMetrics",
    exportActivitiesCSV: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/exportActivitiesCSV",
    getCourseUsersResults: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/getCourseUsersResults",
    processImportJob: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/processImportJob",
    fetchUserGrowthMetrics: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/fetchUserGrowthMetrics",
    fetchCourseUserMetrics: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/fetchCourseUserMetrics",
    sendWelcomeEmail: "http://127.0.0.1:5001/dynamic-art-433118-s1/us-central1/sendWelcomeEmail",
};


const localStaging = {
    getVerificationCode: "http://127.0.0.1:5001/aaim-staging/us-central1/getVerificationCode",
    postVerifyCode: "http://127.0.0.1:5001/aaim-staging/us-central1/postVerifyCode",
    manageCompanyUser: "http://127.0.0.1:5001/aaim-staging/us-central1/manageCompanyUser",
    archiveCompanyUser: "http://127.0.0.1:5001/aaim-staging/us-central1/archiveCompanyUser",
    activateCompanyUser: "http://127.0.0.1:5001/aaim-staging/us-central1/activateCompanyUser",
    manageAdminUser: "http://127.0.0.1:5001/aaim-staging/us-central1/manageAdminUser",
    archiveAdminUser: "http://127.0.0.1:5001/aaim-staging/us-central1/archiveAdminUser",
    activateAdminUser: "http://127.0.0.1:5001/aaim-staging/us-central1/activateAdminUser",
    archiveCourse: "http://127.0.0.1:5001/aaim-staging/us-central1/archiveCourse",
    archiveLessonPlan: "http://127.0.0.1:5001/aaim-staging/us-central1/archiveLessonPlan",
    launchCourse: "http://127.0.0.1:5001/aaim-staging/us-central1/launchCourse",
    launchLessonPlan: "http://127.0.0.1:5001/aaim-staging/us-central1/launchLessonPlan",
    manageCourseUsers: "http://127.0.0.1:5001/aaim-staging/us-central1/manageCourseUsers",
    manageLessonPlanUsers: "http://127.0.0.1:5001/aaim-staging/us-central1/manageLessonPlanUsers",
    fetchDashboardMetrics: "http://127.0.0.1:5001/aaim-staging/us-central1/fetchDashboardMetrics",
    fetchCourseProgressMetrics: "http://127.0.0.1:5001/aaim-staging/us-central1/fetchCourseProgressMetrics",
    exportActivitiesCSV: "http://127.0.0.1:5001/aaim-staging/us-central1/exportActivitiesCSV",
    getCourseUsersResults: "http://127.0.0.1:5001/aaim-staging/us-central1/getCourseUsersResults",
    processImportJob: "http://127.0.0.1:5001/aaim-staging/us-central1/processImportJob",
    fetchUserGrowthMetrics: "http://127.0.0.1:5001/aaim-staging/us-central1/fetchUserGrowthMetrics",
    fetchCourseUserMetrics: "http://127.0.0.1:5001/aaim-staging/us-central1/fetchCourseUserMetrics",
    sendWelcomeEmail: "http://127.0.0.1:5001/aaim-staging/us-central1/sendWelcomeEmail",
};



const localProduction = {
    getVerificationCode: "http://127.0.0.1:5001/aaim-production/us-central1/getVerificationCode",
    postVerifyCode: "http://127.0.0.1:5001/aaim-production/us-central1/postVerifyCode",
    manageCompanyUser: "http://127.0.0.1:5001/aaim-production/us-central1/manageCompanyUser",
    archiveCompanyUser: "http://127.0.0.1:5001/aaim-production/us-central1/archiveCompanyUser",
    activateCompanyUser: "http://127.0.0.1:5001/aaim-production/us-central1/activateCompanyUser",
    manageAdminUser: "http://127.0.0.1:5001/aaim-production/us-central1/manageAdminUser",
    archiveAdminUser: "http://127.0.0.1:5001/aaim-production/us-central1/archiveAdminUser",
    activateAdminUser: "http://127.0.0.1:5001/aaim-production/us-central1/activateAdminUser",
    archiveCourse: "http://127.0.0.1:5001/aaim-production/us-central1/archiveCourse",
    archiveLessonPlan: "http://127.0.0.1:5001/aaim-production/us-central1/archiveLessonPlan",
    launchCourse: "http://127.0.0.1:5001/aaim-production/us-central1/launchCourse",
    launchLessonPlan: "http://127.0.0.1:5001/aaim-production/us-central1/launchLessonPlan",
    manageCourseUsers: "http://127.0.0.1:5001/aaim-production/us-central1/manageCourseUsers",
    manageLessonPlanUsers: "http://127.0.0.1:5001/aaim-production/us-central1/manageLessonPlanUsers",
    fetchDashboardMetrics: "http://127.0.0.1:5001/aaim-production/us-central1/fetchDashboardMetrics",
    fetchCourseProgressMetrics: "http://127.0.0.1:5001/aaim-production/us-central1/fetchCourseProgressMetrics",
    exportActivitiesCSV: "http://127.0.0.1:5001/aaim-production/us-central1/exportActivitiesCSV",
    getCourseUsersResults: "http://127.0.0.1:5001/aaim-production/us-central1/getCourseUsersResults",
    processImportJob: "http://127.0.0.1:5001/aaim-production/us-central1/processImportJob",
    fetchUserGrowthMetrics: "http://127.0.0.1:5001/aaim-production/us-central1/fetchUserGrowthMetrics",
    fetchCourseUserMetrics: "http://127.0.0.1:5001/aaim-production/us-central1/fetchCourseUserMetrics",
    sendWelcomeEmail: "http://127.0.0.1:5001/aaim-production/us-central1/sendWelcomeEmail",
}

const dev = {
    getVerificationCode: "https://getverificationcode-nmnxjott3a-uc.a.run.app",
    postVerifyCode: "https://postverifycode-nmnxjott3a-uc.a.run.app",
    manageCompanyUser: "https://managecompanyuser-nmnxjott3a-uc.a.run.app",
    archiveCompanyUser: "https://archivecompanyuser-nmnxjott3a-uc.a.run.app",
    activateCompanyUser: "https://activatecompanyuser-nmnxjott3a-uc.a.run.app",
    manageAdminUser: "https://manageadminuser-nmnxjott3a-uc.a.run.app",
    archiveAdminUser: "https://archiveadminuser-nmnxjott3a-uc.a.run.app",
    activateAdminUser: "https://activateadminuser-nmnxjott3a-uc.a.run.app",
    archiveCourse: "https://archivecourse-nmnxjott3a-uc.a.run.app",
    archiveLessonPlan: "https://archivelessonplan-nmnxjott3a-uc.a.run.app",
    launchCourse: "https://launchcourse-nmnxjott3a-uc.a.run.app",
    launchLessonPlan: "https://launchlessonplan-nmnxjott3a-uc.a.run.app",
    manageCourseUsers: "https://managecourseusers-nmnxjott3a-uc.a.run.app",
    manageLessonPlanUsers: "https://managelessonplanusers-nmnxjott3a-uc.a.run.app",
    fetchDashboardMetrics: "https://fetchDashboardMetrics-nmnxjott3a-uc.a.run.app",
    fetchCourseProgressMetrics: "https://fetchCourseProgressMetrics-nmnxjott3a-uc.a.run.app",
    exportActivitiesCSV: "https://exportActivitiesCSV-nmnxjott3a-uc.a.run.app",
    getCourseUsersResults: "https://getCourseUsersResults-nmnxjott3a-uc.a.run.app",
    processImportJob: "https://processImportJob-nmnxjott3a-uc.a.run.app",
    fetchUserGrowthMetrics: "https://us-central1-aaim-dev.cloudfunctions.net/fetchUserGrowthMetrics",
    fetchCourseUserMetrics: "https://us-central1-aaim-dev.cloudfunctions.net/fetchCourseUserMetrics",
    sendWelcomeEmail: "https://us-central1-aaim-dev.cloudfunctions.net/sendWelcomeEmail",
};


const staging = {
    getVerificationCode: "https://getverificationcode-kzxdtr2d6a-uc.a.run.app",
    postVerifyCode: "https://postverifycode-kzxdtr2d6a-uc.a.run.app",
    manageCompanyUser: "https://managecompanyuser-kzxdtr2d6a-uc.a.run.app",
    archiveCompanyUser: "https://archivecompanyuser-kzxdtr2d6a-uc.a.run.app",
    activateCompanyUser: "https://activatecompanyuser-kzxdtr2d6a-uc.a.run.app",
    manageAdminUser: "https://manageadminuser-kzxdtr2d6a-uc.a.run.app",
    archiveAdminUser: "https://archiveadminuser-kzxdtr2d6a-uc.a.run.app",
    activateAdminUser: "https://activateadminuser-kzxdtr2d6a-uc.a.run.app",
    archiveCourse: "https://archivecourse-kzxdtr2d6a-uc.a.run.app",
    archiveLessonPlan: "https://archivelessonplan-kzxdtr2d6a-uc.a.run.app",
    launchCourse: "https://launchcourse-kzxdtr2d6a-uc.a.run.app",
    launchLessonPlan: "https://launchlessonplan-kzxdtr2d6a-uc.a.run.app",
    manageCourseUsers: "https://managecourseusers-kzxdtr2d6a-uc.a.run.app",
    manageLessonPlanUsers: "https://managelessonplanusers-kzxdtr2d6a-uc.a.run.app",
    fetchDashboardMetrics: "https://fetchDashboardMetrics-kzxdtr2d6a-uc.a.run.app",
    fetchCourseProgressMetrics: "https://fetchCourseProgressMetrics-kzxdtr2d6a-uc.a.run.app",
    exportActivitiesCSV: "https://exportActivitiesCSV-kzxdtr2d6a-uc.a.run.app",
    getCourseUsersResults: "https://getCourseUsersResults-kzxdtr2d6a-uc.a.run.app",
    processImportJob: "https://processImportJob-kzxdtr2d6a-uc.a.run.app",
    fetchUserGrowthMetrics: "https://fetchusergrowthmetrics-kzxdtr2d6a-uc.a.run.app",
    fetchCourseUserMetrics: "https://fetchCourseUserMetrics-kzxdtr2d6a-uc.a.run.app",
    sendWelcomeEmail: "https://us-central1-aaim-staging.cloudfunctions.net/sendWelcomeEmail",
};


const production = {
    getVerificationCode: "https://getverificationcode-2vkd7ysfdq-uc.a.run.app",
    postVerifyCode: "https://postverifycode-2vkd7ysfdq-uc.a.run.app",
    manageCompanyUser: "https://managecompanyuser-2vkd7ysfdq-uc.a.run.app",
    archiveCompanyUser: "https://archivecompanyuser-2vkd7ysfdq-uc.a.run.app",
    activateCompanyUser: "https://activatecompanyuser-2vkd7ysfdq-uc.a.run.app",
    manageAdminUser: "https://manageadminuser-2vkd7ysfdq-uc.a.run.app",
    archiveAdminUser: "https://archiveadminuser-2vkd7ysfdq-uc.a.run.app",
    activateAdminUser: "https://activateadminuser-2vkd7ysfdq-uc.a.run.app",
    archiveCourse: "https://archivecourse-2vkd7ysfdq-uc.a.run.app",
    archiveLessonPlan: "https://archivelessonplan-2vkd7ysfdq-uc.a.run.app",
    launchCourse: "https://launchcourse-2vkd7ysfdq-uc.a.run.app",
    launchLessonPlan: "https://launchlessonplan-2vkd7ysfdq-uc.a.run.app",
    manageCourseUsers: "https://managecourseusers-2vkd7ysfdq-uc.a.run.app",
    manageLessonPlanUsers: "https://managelessonplanusers-2vkd7ysfdq-uc.a.run.app",
    fetchDashboardMetrics: "https://fetchDashboardMetrics-2vkd7ysfdq-uc.a.run.app",
    fetchCourseProgressMetrics: "https://fetchCourseProgressMetrics-2vkd7ysfdq-uc.a.run.app",
    exportActivitiesCSV: "https://exportActivitiesCSV-2vkd7ysfdq-uc.a.run.app",
    getCourseUsersResults: "https://getCourseUsersResults-2vkd7ysfdq-uc.a.run.app",
    processImportJob: "https://us-central1-aaim-production.cloudfunctions.net/processImportJob",
    fetchUserGrowthMetrics: "https://us-central1-aaim-production.cloudfunctions.net/fetchUserGrowthMetrics",
    fetchCourseUserMetrics: "https://us-central1-aaim-production.cloudfunctions.net/fetchCourseUserMetrics",
    sendWelcomeEmail: "https://us-central1-aaim-production.cloudfunctions.net/sendWelcomeEmail",
};


// Automatically select the configuration based on the environment
const env: string = "production"; // Vite or Node.js environment variables
console.log("Environment: ", env);
switch (env) {
    case 'localDev':
        apiConfig = localDev;
        break;
    case 'localStaging':
        apiConfig = localStaging;
        break;
    case 'development':
        apiConfig = dev;
        break;
    case 'staging':
        apiConfig = staging;
        break;
    case 'production':
        apiConfig = production;
        break;
    default:
        apiConfig = staging;
}

export {apiConfig};


export const release = "3.4.0";

